import {ColDef} from "@ag-grid-community/core";
import DateFilter from "../../common/DateFilter";
import {RowData} from "../types/types";

export const ColumnTypes: {
  [key: string]: ColDef<RowData>;
} = {
  filterColumn: {
    suppressMenu: false,
    menuTabs: ["filterMenuTab"],
    filterParams: {
      buttons: ["apply", "reset"],
      closeOnApply: true
    }
  },
  textFilter: {
    filter: "agTextColumnFilter"
  },
  numberFilter: {
    filter: "agNumberColumnFilter",
    filterParams: {
      filterOptions: [
        "equals",
        "notEqual",
        "lessThan",
        "lessThanOrEqual",
        "greaterThan",
        "greaterThanOrEqual",
        "inRange"
      ]
    }
  },
  dateFilter: {
    filter: DateFilter
  },
  setFilter: {
    filter: "agSetColumnFilter"
  }
};

export const DefaultColDef: ColDef<RowData> = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressMenu: true,
  headerClass: "uppercase-header"
};
